import React from "react";

import { Grid } from "@material-ui/core";
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import AddIcon from '@mui/icons-material/Add';
import TextField from '@mui/material/TextField';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import SaveIcon from '@mui/icons-material/Save';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import Style from "../../../../styles/js/Styles";
import * as Constants from "../../../../consts/Constants.js";

import { ResidueType } from '../../../../plas/services/residues/models';
import service from '../../../../plas/services/residues/service';
import alerter from "../../../alerts/alerter"

export default function Settings({ 
	fullWidth
}) {

	const theme = createTheme({
	  palette: {
	    primary: {
	      main: '#FFFFFF',
	      darker: '#FFFFFF',
	    }
	  },
	});

	const style = Style();

	const [saving, setSaving] = React.useState(false);
	const [loadingTypes, setLoadingTypes] = React.useState(true);
  	const [residueTypeName, setResidueTypeName] = React.useState("");
	const [canSave, setCanSave] = React.useState(false);
  	const [residueTypes, setResidueTypes] = React.useState(null);
	const [selectedType, setSelectedType] = React.useState(null);

	React.useEffect(() => {
		loadTypes()
	}, []);

	const loadTypes = () => {
		service.api.residueTypes.get((response) => {
			if (response.error != null) {
        		alerter.showError(response.error);
			} else {
				let types = response.result
				setResidueTypes(types);
				setLoadingTypes(false);
			}
		});
	}

  	const saveClickHandler = () => {
  		if (selectedType == null) {
  			createResidueType();
  		} else {
  			updateResidueType();
  		}
	}

	const updateResidueType = () => {
		setSaving(true)

		let previousName = selectedType.name;
  		selectedType.name = residueTypeName;
  	
  		service.api.residueTypes.update(selectedType, (response) => {
  			if (response.result != null) {
  				setResidueTypes([...residueTypes]);
  				setSelectedType(null);
  				setResidueTypeName("");
  			} else {
  				selectedType.name = previousName;
  				alerter.showError(response.error);
  			}
			setSaving(false)
  		});
	}

	const createResidueType = () => {
		setSaving(true)

  		let residueType = new ResidueType();
  		residueType.name = residueTypeName;
  		residueType.isEnabled = true;

  		service.api.residueTypes.create(residueType, (response) => {
  			if (response.result != null) {
  				setResidueTypes([...residueTypes, response.result]);
  				setResidueTypeName("");
  			} else {
  				alerter.showError(response.error);
  			}
			setSaving(false)
  		});
	}

	const enableResidueType = (id, enable) => {
		setSaving(true);

		let residueType = residueTypes.find((item) => item.id === id);
		residueType.isEnabled = enable;

		service.api.residueTypes.update(residueType, (response) => {
  			if (response.result != null) {
  				setResidueTypes([...residueTypes]);
  			} else {
  				residueType.isEnabled = !enable;
				alerter.showError(response.error);
  			}
			setSaving(false)
  		});
	}

	const editResidueType = (id) => {
		let residueType = residueTypes.find((item) => item.id == id);

		if (residueType == selectedType) {
			setSelectedType(null);
			setResidueTypeName("");
		} else {
			setSelectedType(residueType);
			setResidueTypeName(residueType.name);
		}

	}

	const onChangeResidueType = (event) => {
	  setResidueTypeName(event.target.value);
	  let duplicated = (residueTypes.find((item) => item.name == event.target.value) != null);
	  setCanSave(!duplicated);
	}

  	const ColoredLine = ({ color }) => (
	    <hr
	        style={{
	            color: color,
	            backgroundColor: color,
	            marginTop: 6,
	            marginBottom: 16,
	            height: 2
	        }}
	    />
	);

	return(
   		<div className={style.box} >
   		{ loadingTypes ?
	        (
	          <div style={{color:Constants.COLOR_PRIMARY}}>
	            <CircularProgress color="inherit" />
	          </div>
	        ) : 
	        (
        	  <Grid container style={{ paddingBottom: '16px' }}>
             	<Grid item xs={false} md={ fullWidth ? false : 2} />
             	<Grid item xs={12} md={ fullWidth ? 12 : 8} >
					<Grid container spacing={2}>
						<Grid item xs={12}>
						  <p style={{ fontSize: '28px', textAlign: 'left'}}>
				            Tipos de residuos
				          </p>
				          <ColoredLine color="gray"/>
						</Grid>
						<Grid item xs={12}>
							<Grid container spacing={2}>
						        <Grid item xs={true}>
						          <TextField
						            variant="outlined" 
						            size="medium"
						            id="residueType"
						            label="Tipo de residuo"
						            name="residueType"
						            value={residueTypeName}
						            disabled={saving}
						            fullWidth
						            onChange={onChangeResidueType}
						            placeholder="Ingresa un nuevo tipo de residuo"/>
						        </Grid>
						        <Grid item xs={'auto'}>
						            <ThemeProvider theme={theme}>
						              <Button 
						                style={{height: '100%'}}
						                disabled={residueTypeName.trim().length === 0 || saving || !canSave}
						                startIcon={ selectedType ? <SaveIcon/> : <AddIcon/>}
						                variant="contained" 
						                fullWidth
						                onClick={saveClickHandler}>
						              <b>{ selectedType ? "Actualizar" : "Agregar"}</b>
						            </Button>
						          </ThemeProvider>
						        </Grid>
						        <Grid item xs={12} style={{ textAlign: 'left'}}>
						            { residueTypes.filter((item) => item.isEnabled).map((item, index) => (
						                <Chip 
						                	key={item.id} 
						                	disabled={saving} 
						                	style={{margin: '4px', fontSize: '15px'}} 
						                	label={item.name}
						                	deleteIcon={<ArrowDownwardIcon />}
						                	variant={item == selectedType ? "filled" : "outlined"}
						                	onClick={() => editResidueType(item.id)}
						                	onDelete={() => enableResidueType(item.id,false)}
						                />
								    ))}
						        </Grid>
						        <Grid item xs={'auto'}>
								  <span style={{ fontSize: '20px', textAlign: 'left'}}>
						            Desactivados
						          </span>
								</Grid>
								<Grid item xs={12} style={{ textAlign: 'left'}}>
						            { residueTypes.filter((item) => !item.isEnabled).map((item, index) => (
						                <Chip 
						                	key={item.id} 
						                	disabled={saving} 
						                	style={{margin: '4px', fontSize: '15px'}} 
						                	label={item.name} 
						                	variant={item == selectedType ? "filled" : "outlined"}
						                	deleteIcon={<ArrowUpwardIcon />}
						                	onClick={() => editResidueType(item.id)}
						                	onDelete={() => enableResidueType(item.id,true)}
						                />
								    ))}
						        </Grid>
						    </Grid>
						</Grid>
	                </Grid>
             	</Grid>
             	<Grid item xs={false} md={ fullWidth ? false : 2} />
	    	  </Grid>
		    )
		}
		</div>
	)

}